module.exports = __webpack_public_path__ + "static/fonts/SCDream5.86bec88.otf";